import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GuestComponent} from '@app/modules/auth/components/guest/guest.component';
import {LoginComponent} from '@app/modules/auth/components/login/login.component';
import {LoginDetailsComponent} from '@app/modules/auth/components/login-details/login-details.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '@app/modules/shared/shared.module';

@NgModule({
  declarations: [
    GuestComponent,
    LoginComponent,
    LoginDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class AuthModule { }
